const PLAYER_AVATARS = ["liliana", "jace", "chandra", "ajani"] as const;

const AVATAR_GLOWS: Record<(typeof PLAYER_AVATARS)[number], string> = {
  liliana: "#b23cf0",
  jace: "#1fa6e0",
  chandra: "#f2581c",
  ajani: "#e2b44c",
};

function avatarAt(seatIndex: number): (typeof PLAYER_AVATARS)[number] {
  return PLAYER_AVATARS[((seatIndex % PLAYER_AVATARS.length) + PLAYER_AVATARS.length) % PLAYER_AVATARS.length];
}

export function playerPortraitAt(seatIndex: number): string {
  return `./portraits/${avatarAt(seatIndex)}.png`;
}

export function playerGlowAt(seatIndex: number): string {
  return AVATAR_GLOWS[avatarAt(seatIndex)];
}
